import  { route_auth, routes_admin, routes_sales_manager,
  routes_content_coordinator, routes_content_director, routes_content_editor } from "./routes/Routes";
import  {ADMIN, CONTENT_COORDINATOR, CONTENT_DIRECTOR,
        CONTENT_EDITOR, SALES_MANAGER  }
        from "./routes/Roles"

/**
 * The route table for a role. Pure function of the role (SCRUM-1172): callers
 * pass the role from Redux via `useUserRole()` instead of handing in
 * `localStorage`, so route gating uses the same single source of truth as the
 * rest of the app (SCRUM-1029). The branches themselves are unchanged: falsy
 * role -> route_auth, unknown role -> [].
 *
 * @param {string | null | undefined} role
 */
const getRoutesArray = (role)=> {
let routes ;
  !role ? routes = route_auth:
  role.toString()=== ADMIN ?routes =  routes_admin : 
  role.toString()=== CONTENT_COORDINATOR ? routes = routes_content_coordinator :  
  role.toString()=== CONTENT_DIRECTOR ?routes =  routes_content_director :  
  role.toString()=== CONTENT_EDITOR ?routes =  routes_content_editor :  
  role.toString()=== SALES_MANAGER ?routes =  routes_sales_manager :
  routes =  []
return routes
} 

                 

export default getRoutesArray;
